module.exports = __webpack_public_path__ + "static/img/花瓶3.59b1c88.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/reliefVase/imgs/花瓶3.png
// module id = etOG
// module chunks = 2